// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-landing-page -> dietz-property-group-landing-page -> pierpont-lp
// Generated: 2026-08-12T21:07:36.031Z
// Counts: 0 design, 5 content, 2 slot group, 2 collection binding, 2 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "hero.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "mappedField": null
  },
  "multihub-lead-capture.lead_source": {
    "overrideType": "VALUE",
    "customValue": "LANDING_PAGE",
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=55/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "mappedField": "custom_google_gtm_id"
  }
};

export const slotGroupOverrides = {
  "header.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "query_params": {
        "type": "VALUE",
        "customValue": "?utm_medium=ppc&utm_source=google&utm_campaign=landing-page"
      }
    }
  },
  "hero.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_22c3c264-8fa0-4cec-a627-4d14c96ce4ff",
      "custom_59745504-11d1-4404-b17c-f3cdb155fe76",
      "custom_8f996c31-d807-4470-bdda-ddd74161e3ed",
      "custom_9b79288f-82f0-495a-9668-3f81ffa016ee",
      "custom_56abc074-1306-4b8e-a680-be2a72e061a1",
      "custom_94d53a9a-5478-481b-9f01-e2b3984131b5",
      "custom_2f1c0245-0614-4c96-ab79-58bcfdf75274",
      "custom_9c9db002-83d7-4011-a48f-759e79582060",
      "custom_e3f424fe-46b4-46ed-ae91-1b04c184cbe1",
      "custom_71bb8904-23bf-4e1a-8b83-279a19c8aa1e",
      "custom_ab4b7b16-5d1a-4856-9ddc-04ddad979628",
      "custom_7055e1b3-a4b2-402c-a3b7-b1951f037280",
      "custom_e21e46a5-dde5-40e8-9939-9ea1a01af1ba",
      "custom_c95e7050-4f46-4ce9-a2c9-ff3b7343aa5e",
      "custom_183d4b72-3559-4cff-8ba3-1526b8444ea1",
      "custom_b8081e20-ba83-459e-bc68-9171ec5663ce",
      "custom_0857ab92-37a4-4083-be15-f15199e1ff96",
      "custom_8f8924c8-40dd-4ed3-8814-1b7f7ff7045d"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "neighborhoodmap.pois": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
